import { ActionBase } from '../actions/action-base';
//
// Library
//
import * as Library from '../../../lib/core/library/index';
//
// Modell
//
import { SpecialOffer } from '../../../lib/angular/model/dealer/special-offer/special-offer';
//
// Actions
//
import {
  LOCAL_SPECIAL_ACTION,
  LocalSpecialActionLoad,
  LocalSpecialActionSet,
  LocalSpecialActionClear,
} from '../actions/local-special.action';
//
// Reducer Interface
//
export interface ILocalSpecial {
  hasItems: boolean;
  items: SpecialOffer[];
}
//
// Initial State
//
export const LOCAL_SPECIAL_INITIAL_STATE: ILocalSpecial = {
  hasItems: false,
  items: []
};

/* tslint:disable:no-switch-case-fall-through */
export function LocalSpecialReducer(
  state = LOCAL_SPECIAL_INITIAL_STATE,
  action: ActionBase
): ILocalSpecial {
  //
  // Switch on Action Type
  //
  switch (action.type) {
    case LOCAL_SPECIAL_ACTION.LOAD:
      return _onLoad(state, action as LocalSpecialActionLoad);
    case LOCAL_SPECIAL_ACTION.SET:
      return _onSet(state, action as LocalSpecialActionSet);
    case LOCAL_SPECIAL_ACTION.CLEAR:
      return _onClear(state, action as LocalSpecialActionClear);
    default: {
      return state;
    }
  }
}
//
// General Functions
//
export function LoadLocalSpecial(state: ILocalSpecial) {
  return state;
}

//
// _onLoad()
//
function _onLoad(state: ILocalSpecial, action: LocalSpecialActionLoad): ILocalSpecial {
  return Object.assign({}, state);
}

//
// _onSet()
//
function _onSet(state: ILocalSpecial, action: LocalSpecialActionSet): ILocalSpecial {
  const _state = Object.assign({}, state, {
    items: action.payload,
    hasItems: Library.isArrayWithLength(action.payload)
  });
  //
  // Do Work...
  //
  return _state;
}

//
// _onClear()
//
function _onClear(state: ILocalSpecial, action: LocalSpecialActionClear): ILocalSpecial {
  //
  // Do Work...
  //
  return Object.assign({}, state, { items: [] });
}

